import { Factory } from 'rosie';

import '../conversation_item_factory';
import IdGenerator from '../lib/id_generator';

Factory.define('TaskTopicChange').attr('type', 'TASK_TOPIC_CHANGE');

Factory.define('TaskTopicChangeWithDefaults')
  .extend('TaskTopicChange')
  .attr('taskId', IdGenerator.newId())
  .attr('addedTopics', [IdGenerator.newId()])
  .attr('removedTopics', [IdGenerator.newId()]);

Factory.define('TaskTopicChangeItem')
  .extend('ConversationItem')
  .attr('content', ['content'], content => Factory.attributes('TaskTopicChange', content));

Factory.define('TaskTopicChangeItemWithDefaults')
  .extend('ConversationItemWithDefaults')
  .attr('content', ['content'], function (content) {
    return Factory.attributes('TaskTopicChangeWithDefaults', content);
  })
  .attr('initiator', {
    type: 'AGENT',
    id: IdGenerator.newId(),
  });

Factory.define('TaskTopicChangeItemWithRuleInitiator')
  .extend('ConversationItemWithDefaults')
  .attr('content', ['content'], function (content) {
    return Factory.attributes('TaskTopicChangeWithDefaults', content);
  })
  .attr('initiator', {
    type: 'AUTOMATION',
    id: IdGenerator.newId(),
  });
